(function(){
    'use strict';

    angular
    .module('app')
    .controller('ContentController', ContentController)
    .constant("prefixCampos", "_campo_");
 
    ContentController.$inject = ['ContentService',"$http","$timeout","$uibModal", "$log", "$document","$sce",'prefixCampos'];
              
    function ContentController(ContentService,$http,$timeout,$uibModal, $log, $document,$sce,prefixCampos)
    {                         
        var vm = this; 
        vm.prefixCampos = prefixCampos; 
        vm.loading = true;
        console.log("content cont");
        vm.type = "";
        vm.camposHtml = "";
        vm.lang_id = "";
        vm.lang_id_copy = "";
        vm.duplicar = "";
        vm.content_id = "";
        vm.campos = "";
        vm.camposActual = [];
        vm.languages = [];
        vm.url_count = window.location.href + '&count=1';

        vm.refreshPageParams = function(){
            
        }
        
        vm.validate = function(form){
            var res = false;
            if(typeof(form.$error.required)!='undefined'){
                for(var cont=0;cont<form.$error.required.length;cont++){
                    var value = ""+form.$error.required[cont].$viewValue;
                    ////console.log(form.$error.required[cont]);
                    if(($('#'+form.$error.required[cont].$name).is(":visible") || $('#'+form.$error.required[cont].$name+"_tag").is(":visible")) && value.trim()==''){
                       res = true;
                    }
                }
            }
            return res;
            //return form.$invalid;
            
        }


        vm.borrarModal = "";
        vm.borrarContenido = function(id,type){
            ////console.log("borando popup");
            vm.borrarModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  windowClass: 'modal-danger',
                  templateUrl: 'borrarcontenidopopup.html',
                  size: 'sm',
                  windowClass: 'modal-sm',
                  
                  controller: function($scope) {
                    $scope.okForm = function(){
                        ContentService.borrarContenido(id,type,function(data){
                            location.reload();
                        });
                        vm.borrarModal.close();
                    }
                    $scope.koForm = function(){
                        vm.borrarModal.close();
                    }
                  }
            });
        }


        
       
            
        vm.init = function(type,content_id,lang_id_copy,duplicar,modelSearch=null){
            vm.type=type;
            vm.lang_id_copy = lang_id_copy;
            vm.duplicar = duplicar;
            vm.content_id = content_id;
            ////console.log(modelSearch);
            if(modelSearch!=null && modelSearch!= '' && modelSearch!= '""'){
                vm.modelSearch = JSON.parse(modelSearch);
            }
            ContentService.getCampos(vm,function(data){
                vm.languages = data.languages;
                vm.campos = data.campos;
                for(var cont=0;cont<data.campos.length;cont++){
                    for(var cont2=0;cont2<data.languages.length;cont2++){
                        if(modelSearch!=null && modelSearch!= ''){
                            if(typeof(vm.modelSearch["ContentSearch"]) != 'undefined' && typeof(vm.modelSearch["ContentSearch"][data.campos[cont]["name"]]) != 'undefined'){
                                if(data.campos[cont].multilang==1 || cont2<1){
                                    vm.camposActual[vm.prefixCampos+data.campos[cont]["name"]+"_"+data.languages[cont2].id] = vm.modelSearch["ContentSearch"][data.campos[cont]["name"]];
                                }
                                ////console.log(vm.camposActual);

                            }
                        }
                        if(typeof(data.node[data.languages[cont2].id])!='undefined'){
                            vm.camposActual[vm.prefixCampos+data.campos[cont]["name"]+"_"+data.languages[cont2].id] = data.node[data.languages[cont2].id][data.campos[cont]["name"]];
                        }
                    }
                }
                vm.camposHtml = data.html;
                vm.loading = false;
            });
        }

        vm.initPopup = function(type,content_id,lang_id_copy,duplicar,modelSearch=null){
            vm.type=type;
            vm.lang_id_copy = lang_id_copy;
            vm.duplicar = duplicar;
            vm.content_id = content_id;
            /*if(modelSearch!=null && modelSearch!= ''){
                vm.modelSearch = JSON.parse(modelSearch);
            }*/
            ContentService.getCampos(vm,function(data){
                /*vm.campos = data.campos;
                for(var cont=0;cont<data.campos.length;cont++){
                    vm.camposActual[vm.prefixCampos+data.campos[cont]["name"]] = data.campos[cont]["value"];
                    if(modelSearch!=null && modelSearch!= '' && modelSearch!= '""'){
                        if(typeof(vm.modelSearch["ContentSearch"][data.campos[cont]["name"]]) != 'undefined'){
                            vm.camposActual[vm.prefixCampos+data.campos[cont]["name"]] = vm.modelSearch["ContentSearch"][data.campos[cont]["name"]];
                        }
                    }
                }
                vm.camposHtml = data.html;*/
                vm.loading = false;
                vm.contentCreateModal = "";
                vm.msgokModal = "";
                vm.contentCreateModal = $uibModal.open({
                      animation: true,
                      ariaLabelledBy: 'modal-title-top',
                      ariaDescribedBy: 'modal-body-top',
                      templateUrl: 'contentpopup.html',
                      size: 'lg',
                      controller: function($scope) {
                        $scope.cc = angular.copy(vm);
                        if(modelSearch!=null && modelSearch!= ''){
                            $scope.cc.modelSearch = JSON.parse(modelSearch);
                        }else{
                            $scope.cc.modelSearch = null;
                        }
                        console.log("modelSearch",$scope.cc.modelSearch);
                        $scope.cc.languages = data.languages;
                        $scope.cc.campos = data.campos;
                        $scope.camposHtml = data.html;
                        $timeout(function(){
                            for(var cont=0;cont<data.campos.length;cont++){
                                for(var cont2=0;cont2<data.languages.length;cont2++){
                                    if(modelSearch!=null && modelSearch!= ''){
                                        if(typeof($scope.cc.modelSearch["ContentSearch"]) != 'undefined' && typeof($scope.cc.modelSearch["ContentSearch"][data.campos[cont]["name"]]) != 'undefined'){
                                            if(data.campos[cont].multilang==1 || cont2<1){
                                                $scope.cc.camposActual[$scope.cc.prefixCampos+data.campos[cont]["name"]+"_"+data.languages[cont2].id] = $scope.cc.modelSearch["ContentSearch"][data.campos[cont]["name"]];

                                                console.log("ENTRO",$scope.cc.modelSearch["ContentSearch"][data.campos[cont]["name"]]);
                                                
                                            }

                                        }
                                    }
                                    if(typeof(data.node[data.languages[cont2].id])!='undefined'){
                                        $scope.cc.camposActual[$scope.cc.prefixCampos+data.campos[cont]["name"]+"_"+data.languages[cont2].id] = data.node[data.languages[cont2].id][data.campos[cont]["name"]];
                                    }
                                }
                            }
                        })
                        
                        //console.log("camposActual",$scope.cc.camposActual);
                        
                        $scope.okForm = function(){
                            console.log("scope",$scope.cc);
                            vm.saveContenido($scope.cc,function(){
                                //location.reload();
                                vm.contentCreateModal.close();
                                vm.msgokModal = $uibModal.open({
                                      animation: true,
                                      ariaLabelledBy: 'modal-title-top',
                                      ariaDescribedBy: 'modal-body-top',
                                      templateUrl: 'msgok.html',
                                      size: 'lg',
                                      controller: function($scope) {
                                        $scope.okForm = function(){
                                            vm.msgokModal.close();
                                        }
                                      }
                                });
                            });
                            vm.contentCreateModal.close();
                        }
                        $scope.koForm = function(){
                            vm.contentCreateModal.close();
                        }
                      }
                });
            });
            
        }

        vm.msgokSaveModal = "";
        vm.saveContenido = function(contVm,callback){
            contVm.loading=true;
            for(var cont=0;cont<contVm.campos.length;cont++){
                contVm.campos[cont]['value'] = {};
                for(var cont2=0;cont2<contVm.languages.length;cont2++){
                    contVm.campos[cont]['value'][contVm.languages[cont2].id] = {"value" : contVm.camposActual[contVm.prefixCampos+contVm.campos[cont]["name"]+"_"+contVm.languages[cont2].id] };
                    if(!contVm.campos[cont].multilang){
                        break;
                    }
                }
            }
            ContentService.saveCampos(contVm,function(data){
                contVm.content_id = data.content_id;
                $('#idioma option').each(function(){
                    if($(this).val()!=data.lang_id){
                        $(this).remove();
                    }
                })
                contVm.duplicar="";
                //contVm.loading=false;
                /*contVm.msgokSaveModal = $uibModal.open({
                      animation: true,
                      ariaLabelledBy: 'modal-title-top',
                      ariaDescribedBy: 'modal-body-top',
                      templateUrl: 'msgokreturn.html',
                      size: 'lg',
                      controller: function($scope) {
                        $scope.contVm = contVm;
                        $scope.okForm = function(){
                            contVm.msgokSaveModal.close();
                        }
                      }
                });*/
                //console.log(data);
                if(typeof(callback)!='undefined'){
                    callback(data,contVm.camposActual);
                }else{
                    if(data.view_button!=''){
                        window.location.href = "/backend"+data.view_button+"?type="+contVm.type+"&id="+contVm.content_id+"&lang_id="+contVm.lang_id;
                    }else{
                        window.location.href = "/backend/altcrm/content/view?type="+contVm.type+"&id="+contVm.content_id+"&lang_id="+contVm.lang_id;
                    }
                }
            });
        }
    } 
  
})();